import { render, staticRenderFns } from "./RightsFundBill.vue?vue&type=template&id=6dfe9b32"
import script from "./RightsFundBill.vue?vue&type=script&lang=js"
export * from "./RightsFundBill.vue?vue&type=script&lang=js"
import style0 from "./RightsFundBill.vue?vue&type=style&index=0&id=6dfe9b32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports